
import { useSelector } from "react-redux"
export default function({filtered}) {
    const mainOverview = useSelector((state) => state.projects)
    const filteredOverview = mainOverview.filteredOverview
    const overview = !filtered?mainOverview:filteredOverview
    const { leastPerforming, topPerforming, projects } = overview
    const scrollToProject = (e) => {
        const { projecturl, branch } = e.currentTarget.dataset
        const projectElement = document.querySelector(`[id='project-${projecturl}'][data-branch='${branch}']`)
        if(!projectElement.classList.contains("project-metrics-shown")) projectElement.click()
        setTimeout(() => {
            const projectMetrics = document.getElementById(`project-${projecturl}-metrics`)
            projectMetrics.scrollIntoView({block: "center", inline: "center", behavior: "smooth" })
        }, 0)
    }
    const checkDuplicateProjectName = (projectName) => {
        return projects.filter(({projectUrl}) => projectUrl === projectName).length > 1
    }
    return <div className="py-2 px-4 rounded-md text-left bg-slate-50 shadow-md h-[332px] min-w-[250px] ">
        <div className="top-performings mb-5">
            <h1 className="font-semibold mb-2">Most improved</h1>
            {topPerforming.length ? topPerforming.map((project, i) => {
                const isDuplicate = checkDuplicateProjectName(project.projectUrl) 
                return <div key={"top-"+i+project.projectUrl} data-projecturl={project.projectUrl} data-branch={project.projectBranch} className="flex py-1 px-2 border-b-2 rounded-md cursor-pointer hover:bg-slate-100" onClick={scrollToProject}>
                    <h1 title={project.projectUrl} className="mr-2 truncate">{project.projectUrl + `${isDuplicate ? ":" + project.projectBranch: ""}`}</h1>
                    <img src={require(`./../../images/${i+1}.increase.png`)}></img>
                </div>
            }): <div className="flex py-1 px-2 border-b-2 rounded-md ">
                <h1>No improvements for this selection</h1>
            </div>}
        </div>
        <div className="least-performings">
            <h1 className="font-semibold mb-2">Underachievers</h1>
            {leastPerforming.length ? leastPerforming.map((project,i) => {
                const isDuplicate = checkDuplicateProjectName(project.projectUrl) 
                return <div key={"least-"+i+project.projectUrl} data-projecturl={project.projectUrl} data-branch={project.projectBranch} className="flex py-1 px-2 border-b-2 rounded-md cursor-pointer hover:bg-slate-100" onClick={(e) => scrollToProject(e)}>
                    <h1 title={project.projectUrl} className="mr-2 truncate">{project.projectUrl + `${isDuplicate ? ":" + project.projectBranch: ""}`}</h1>
                    <img src={require(`./../../images/${i+1}.decrease.png`)}></img>
                </div>
            }): <div className="flex py-1 px-2 border-b-2 rounded-md ">
                <h1>No underperforming projects for this selection</h1>
            </div>}
        </div>

    </div>
}